<template>
	<div class="header">
		<div :class="`head-set ${addClass}`">
			<div class="head-title">
				<h2 class="page-title">
					<img v-bind:src="image" v-bind:alt="alt" class="over_display" />
					<img v-bind:src="imageSp" v-bind:alt="alt" class="under_display" />
				</h2>
			</div>
			<div :class="`intro ${addClass}`">
				<p v-html="intro" class="u-font-ots"></p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'link-card',
	props: {
		image: String,
		imageSp: String,
		alt: String,
		// headCatch: String,
		intro: String,
		addClass: String,
	},
};
</script>

<style lang="scss" scoped>
.head-set {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 0 auto;
	margin-top: 150px;
	// margin-bottom: 300px;
	@media print, screen and (max-width: 1160px) {
		width: 90%;
		margin-top: 50px;
		// margin-bottom: 100px;
	}
	&.is-platform {
		@media print, screen and (min-width: 1161px) {
			max-width: 705px;
		}
	}
	&.is-embedded {
		@media print, screen and (min-width: 1161px) {
			max-width: 750px;
		}
	}
	&.is-robot {
		@media print, screen and (min-width: 1161px) {
			max-width: 840px;
		}
	}
	&.is-dxai {
		@media print, screen and (min-width: 1161px) {
			max-width: 610px;
		}
	}
}
.head-title {
	position: relative;
}
// .head-catch {
//   position: absolute;
//   font-family: 'Noto Serif JP', serif;
//   font-size: 52px;
//   top: 50%;
//   margin: 0;
//   @media print, screen and (min-width: 1161px) {
//     white-space: nowrap;
//     transform: translate(-50%,-50%);
//     left: 50%;
//   }
//   @media print, screen and (max-width: 1160px) {
//     font-size: 18px;
//     transform: translateY(-50%);
//   }
// }
.page-title {
	width: 100%;
	img {
		width: 100%;
	}
}
.intro {
	font-family: 'Noto Serif JP', serif;
	font-size: 20px;
	margin-top: 30px;
	text-align: justify;
	@media print, screen and (max-width: 1160px) {
		font-size: 14px;
		margin-top: 60px;
	}
	&.is-platform {
		@media print, screen and (min-width: 1161px) {
			margin-top: -0.5em;
			margin-left: 0.5em;
			p {
				letter-spacing: -0.1em;
				white-space: nowrap;
			}
		}
	}
	&.is-embedded {
		@media print, screen and (min-width: 1161px) {
			margin-top: 4.5em;
			margin-left: 1em;
			p {
				letter-spacing: -0.1em;
				white-space: nowrap;
			}
		}
	}
	&.is-robot {
		@media print, screen and (min-width: 1161px) {
			margin-top: 4.3em;
			margin-left: 3em;
			p {
				letter-spacing: -0.1em;
				white-space: nowrap;
			}
		}
	}
	&.is-dxai {
		@media print, screen and (min-width: 1161px) {
			margin-top: 2em;
			margin-left: 1.8em;
			p {
				letter-spacing: -0.1em;
				white-space: nowrap;
			}
		}
	}
	p {
		line-height: calc(55 / 20);
		letter-spacing: 0;
		@media print, screen and (max-width: 1160px) {
			line-height: calc(63 / 28);
		}
	}
}
</style>
